import {
  IProductSlotState,
  IQuantifiedProductSlotState,
} from "@/types/db/product-slot-state";

// returns accountingValue if its an automatically booked addon
// otherwise returns priceValue
export function getPSSValue(
  pss: IProductSlotState | IQuantifiedProductSlotState
) {
  if (pss.hasAutomaticAddons && pss.isChillonPackage) {
    // if main ticket with automatic addons, with some addons containing accountingValue (Chillon's case)
    return pss.accountingValue || 0;
  } else if (pss.isAutomaticAddon && pss.accountingValue) {
    // if pss is an automatic addon, contains an accounting value (Chillon's case)
    return pss.accountingValue;
  } else {
    return pss.priceValue;
  }
}
